import {
  EDIT_RECEIVER_POSTAL_NAME,
  EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS,
  EDIT_RECEIVER_STATE_NAME,
  EDIT_RECEIVER_STREET_NAME,
  EDIT_RECEIVER_SUBURB_NAME,
} from 'constants';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import useUpdateReceiverStore from '../hooks/useUpdateReceiverStore';

const withUpdateReceiverResidentialAddressValidationInitial = (Component) => {
  const UpdateReceiverResidentialAddressValidationInitialComponent = (
    props,
  ) => {
    const {
      validation,
      setValidation,
      addressStreetConfig,
      addressStateConfig,
      addressSuburbConfig,
      addressPostcodeConfig,
    } = props || {};

    const { currentReceiver } = useUpdateReceiverStore();
    const { address } = currentReceiver || {};
    const { street, suburb, city, postcode } = address || {};

    useEffect(() => {
      if (isEmpty(currentReceiver)) return;

      const fields = [
        {
          visible: addressStreetConfig?.visible,
          value: street,
          key: EDIT_RECEIVER_STREET_NAME,
          msg: EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[0].msgRequired,
        },
        {
          visible: addressSuburbConfig?.visible,
          value: suburb,
          key: EDIT_RECEIVER_SUBURB_NAME,
          msg: EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[1].msgRequired,
        },
        {
          visible: addressStateConfig?.visible,
          value: city,
          key: EDIT_RECEIVER_STATE_NAME,
          msg: EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[2].msgRequired,
        },
        {
          visible: addressPostcodeConfig?.visible,
          value: postcode,
          key: EDIT_RECEIVER_POSTAL_NAME,
          msg: EDIT_RECEIVER_RESIDENTIAL_ADDRESS_FIELDS[3].msgRequired,
        },
      ];

      setValidation((prev) => {
        const next = { ...prev };

        fields.forEach(({ visible, value, key, msg }) => {
          if (visible && !value) {
            next[key] = msg;
          }
        });

        return next;
      });
    }, [
      currentReceiver,
      street,
      suburb,
      city,
      postcode,
      addressStreetConfig?.visible,
      addressSuburbConfig?.visible,
      addressStateConfig?.visible,
      addressPostcodeConfig?.visible,
    ]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverResidentialAddressValidationInitialComponent;
};

export default withUpdateReceiverResidentialAddressValidationInitial;
